exports.getPrograms = async function (state) {
  return state.programsDB.get('programs')
}
